import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useStyles } from './LeaveStatus/InternalStyle';

function PeopleOnLeave({ employeesOnLeave }) {
  const classes = useStyles();

  return (
    <>
      <Typography sx={{ fontWeight: 'bold', alignSelf: 'baseline' }}>
        On Leave Today
      </Typography>
      <Grid container>
        {employeesOnLeave?.length == 0 ? (
          <Grid item xs={12} className={classes.textAlighFeature}>
            <Typography variant="subtitle1">
              No employee on leave today
            </Typography>
          </Grid>
        ) : (
          employeesOnLeave?.map((user, i) => {
            return (
              <Grid item md={3} sm={4} xs={2} key={i}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <AccountCircle color="primary" sx={{ fontSize: 50 }} />
                  <Typography sx={{ textAlign: 'center' }} variant="subtitle1">
                    {user.firstName}
                  </Typography>
                </Box>
              </Grid>
            );
          })
        )}
      </Grid>
    </>
  );
}

export default PeopleOnLeave;
